import { Component, Input } from '@angular/core';
import { StatusType } from '../../types/status.type';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-dot-status',
    imports: [NgClass],
    templateUrl: './status-dot.component.html',
    styleUrl: './status-dot.component.scss'
})
export class DotStatusComponent {
@Input() status:string | undefined;
}
